import React from 'react'
import Svg, { Path } from 'react-native-svg'

export const LockedQuiz = (props: any) => {
  const { variant, style } = props
  let size = 28

  if (variant === 'medium') {
    size = 36
  }

  return (
    <Svg style={style} width={size} height={size} viewBox="0 0 36 36" fill="red">
      <Path
        d="M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z"
        fill="rgba(255, 255, 255, .1)"
      />
      <Path
        translateY={2}
        x="2"
        d="M15.0475 24.7647V18.7085H11.4297C10.9264 18.7085 10.5864 18.1234 10.8312 17.6406L15.8363 7.15189C16.1491 6.46435 17.1148 6.71304 17.1148 7.48835V13.6177H20.5694C21.0726 13.6177 21.399 14.1883 21.1814 14.671L16.3396 25.0866C16.0131 25.7887 15.0475 25.5401 15.0475 24.7647Z"
        fill="white"
      />
    </Svg>
  )
}
